<template>
	<v-dialog width="600px" persistent v-model="showDialog">
		<v-card class="pa-2 rounded-lg">
			<div class="pa-4">
				<v-layout wrap class="mb-2">
					<v-flex class="mr-5" xs12 md4 lg4>
						<div class="caption text--disabled">
							Transferring Credits to
						</div>
						<strong class="headline blue-grey--text text--darken-1"
							>+{{ retailerDetails.phoneNo }}</strong
						>
					</v-flex>
					<v-flex xs12 md4 lg3 v-if="retailerDetails.name">
						<div class="caption text--disabled">TeamName</div>
						<strong
							class="headline light-blue--text text--darken-4"
							>{{ retailerDetails.name }}</strong
						>
					</v-flex>
				</v-layout>
				<v-layout class="mb-2">
					<v-flex xs12 md4>
						<div class="caption text--disabled">
							Available Balance
						</div>
						<strong class="headline green--text text--dark-1">
							<span>&#8377;</span>
							{{ availableCredits.toLocaleString() }}/-
						</strong>
					</v-flex>
					<v-flex>
						<img
							:src="
								require(`../../assets/${
									isRummyOptionSelected
										? 'jeet11-rummy'
										: 'jeet11'
								}.png`)
							"
							alt="Logo"
							class="app-logo"
						/>
					</v-flex>
				</v-layout>
				<v-layout class="mb-2">
					<v-text-field
						v-model="amount"
						label="Credits"
						prepend-icon="account_balance_wallet"
						placeholder="Enter the amount"
						:rules="[
							requiredRule,
							onlyDigitRule,
							isValueAllowedRules
						]"
						maxlength="6"
						class="text-field-wrapper pt-4"
					></v-text-field>
				</v-layout>
				<v-layout mb-4>
					<v-flex xs12 md4 lg3 class="d-flex">
						<v-text-field
							label="Enter mPin"
							v-model="mPin"
							@keyup.enter="transferCredits()"
							class="text-field-wrapper pt-4"
							placeholder="* * * *"
							type="password"
						></v-text-field>
					</v-flex>
					<v-flex class="allCenteredChild">
						<v-btn
							outline
							:color="themeInputColor"
							small
							class="btn body-1"
							@click="forgetMpin()"
							>Set/Reset mPin ?</v-btn
						>
					</v-flex>
				</v-layout>
				<v-layout class="d-flex justify-space-between">
					<v-btn
						class="mx-0 mr-4 white--text btn"
						:disabled="isFormDisabled()"
						:color="themeInputColor"
						:loading="loading"
						@click="transferCredits()"
						>Confirm</v-btn
					>
					<v-btn class="btn" color="error" outline @click="closeModal"
						>Cancel</v-btn
					>
				</v-layout>
			</div>
			<!-- <v-card-text>
				<div class="info-container">
					<h5 class="subheading ma-0">Transferring Credits to</h5>
					<p v-if="retailerDetails" class="blue--text Fw600">
						{{ retailerDetails.name }}
					</p>
					<div v-if="retailerDetails">
						{{ retailerDetails.phoneNo }}
					</div>
				</div>
				<div class="info-container">
					<h5 class="subheading ma-0">Available Balance</h5>
					<p class="green--text Fw600">{{ availableCredits }}</p>
				</div>
				<v-flex xs12>
					<v-text-field
						v-model="amount"
						type="number"
						min="0"
						label="Credits"
					></v-text-field>
				</v-flex>
				<v-layout>
					<v-flex xs4>
						<v-text-field
							v-model="mPin"
							label="Enter mPIN"
							placeholder="****"
							type="password"
						></v-text-field>
					</v-flex>
					<v-flex xs4 offset-xs3 class="allCenteredChild">
						<v-btn
							small
							outline
							:color="themeInputColor"
							@click="forgetMpin()"
							>Set/Reset mPin ?</v-btn
						>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-layout row wrap class="justify-space-between px-2 pb-2">
				<v-btn
					:disabled="isFormDisabled()"
					:color="themeInputColor"
					:loading="loading"
					class="white--text"
					@click="transferCredits()"
					>Transfer</v-btn
				>
				<v-btn @click="closeModal">Close</v-btn>
			</v-layout> -->
		</v-card>
	</v-dialog>
</template>
<script>
import { _checkDecimalFormat, _requiredRule, _onlyDigitsRule } from "@/utils";
export default {
	name: "TransferCredits",
	props: [
		"model",
		"themeInputColor",
		"retailerDetails",
		"availableCredits",
		"forgetMpin",
		"loading",
		"isRummyOptionSelected"
	],
	data() {
		return {
			showDialog: true,
			amount: null,
			mPin: undefined,
			requiredRule: (v) => _requiredRule(v),
			onlyDigitRule: (v) => _onlyDigitsRule(v),
			isValueAllowedRules: (v) => {
				if (Number(v) > this.availableCredits) {
					return "Insufficient Account Balance";
				}
				return true;
			}
		};
	},
	methods: {
		transferCredits() {
			let payload = {
				amount: Math.round(Number(this.amount) * 100) / 100,
				userId: this.retailerDetails.userId,
				mPin: this.mPin
			};
			this.$emit("TRANSFER_CREDITS", payload);
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		isFormDisabled() {
			return (
				!this.amount ||
				(this.amount && !_checkDecimalFormat(this.amount)) ||
				parseFloat(this.amount) > parseFloat(this.availableCredits) ||
				!this.mPin ||
				(this.mPin && this.mPin.length !== 4)
			);
		}
	}
};
</script>
<style scoped>
.info-container {
	margin-bottom: 10px;
}
.info-container > div {
	color: #777;
	font-size: 12px;
}
.info-container > p {
	margin: 0;
	font-size: 16px;
}
.rounded-lg {
	border-radius: 16px;
}
.app-logo {
	width: 150px;
	height: 60px;
	object-fit: contain;
}
</style>
